/*Clase que representa la entidad de respuestas*/
export class Answer {

    /**Identificador del registro respuesta*/
    public respuestaId: number;


    constructor(
        /**Identificador del evaluado*/
        public credencialId: number,
        /**Identificador del Item*/
        public itemId: number,
        /**Fecha de creación del registro*/
        public fechaRespuesta: Date,
        /**Valor seleccionado como respuesta */
        public valorRespuesta: string,
        /**Indica si fue enviado al servidor o no */
        public sincronizado:string,
        /**Indica la sesión a la que se encuentra asociada la respuesta*/
        public sesion: number,
        /**Indica el orden del item*/
        public itemOrden: number,
        /**Indica la ipPublica desde donde es enviada la respuesta */
        public ipPublica: string,
        /**Indica la Respuesta abierta para un item tipo 4*/
        public respuestaAbierta: string,
        /**Indica si la respuesta ha sido marcada para revisión*/
        public marcarRespuesta:number,
        /**Archivo de respuesta*/
        public file:File = null

     ) {}
}
